import React, {useEffect, useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {searchAllInputInfo} from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import {CANDIDATE_INPUT_INFO_TYPES, ResponseCode} from '@app/constants/Common';
import {showMessage} from '@app/constants/Messages';
import AllUserInputField from '@pages/candidate/commonview/AllUserInputField';
import {showSuccessMessageSaveData} from '@pages/candidate/Common';
import DVTJCUVSearchCddJobModal from '@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobModal';
import JobSendRequestHistoryModal from "@pages/candidate/detail/JobSendRequestHistoryModal";
import JobFindModeHistoryModal from "@pages/candidate/detail/JobFindModeHistoryModal";
import {DateRange} from '@components';

const CandidateJobSeeking = (props) => {
    const [isEditJobSeeking, setIsEditJobSeeking] = useState(false);
    const [isShowSearchCddJobModal, setIsShowSearchCddJobModal] = useState(false);
    const [showJobFindModeHistoryModal, setShowJobFindModeHistoryModal] = useState(false);
    const [jobSeeking, setJobSeeking] = useState({});
    const [allJobSeekingInfo, setAllJobSeekingInfo] = useState({});
    const {
        candidateId,
        initialJobSeeking,
        onChange,
        onSave,
        mode = 'Edit',
        isEdit = false

    } = props

    useEffect(() => {
        setJobSeeking(initialJobSeeking || {});
    }, [initialJobSeeking]);

    const onChangeJobSeeking = (event) => {
        jobSeeking[event.target.name] = event.target.value
        setJobSeeking({...jobSeeking})

        if (onChange) {
            onChange(jobSeeking);
        }
    }

    const fetchJobSeeking = async (canId) => {
        const res = await CandidateService.getJobSeeking(canId)
        setJobSeeking(res.content)
        const allJobSeekings = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.JobSeeking)
        setAllJobSeekingInfo(allJobSeekings)
    };

    const updateJobSeeking = () => {
        CandidateService.updateJobSeekingDetail({candidate_id: candidateId, job_seeking: jobSeeking}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEditJobSeeking(false)
            if (res.sts_code === ResponseCode.SUCCESS) {
                fetchJobSeeking(candidateId)
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    useEffect(() => {
        if (candidateId) {
            (async () => {
                await fetchJobSeeking(candidateId);
            })();
        }
    }, [candidateId])
    useEffect(() => {
        setIsEditJobSeeking(isEdit);
    }, [isEdit]);


    const onChangeLastDate = (event) => {
        if (!jobSeeking.last_on_dvtjcuv_find_job_mode_date_time) {
            jobSeeking.last_on_dvtjcuv_find_job_mode_date_time = {start_date: '', end_date: ''};
        }
        jobSeeking.last_on_dvtjcuv_find_job_mode_date_time[event.target.name] = event.target.value
        setJobSeeking({...jobSeeking})

        if (onChange) {
            onChange(jobSeeking);
        }
    }


    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Job Seeking</h3>
                    {mode !=='Search' && (
                    <div className='card-tools'>
                        {isEditJobSeeking &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEditJobSeeking(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEditJobSeeking &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateJobSeeking();
                                    }}
                            >
                                Save
                            </button>
                        }
                        {!isEditJobSeeking &&
                            <>
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setIsShowSearchCddJobModal(true)
                                        }}
                                >
                                    Tìm Job
                                </button>
                                <button type='button'
                                        className='btn btn-default'
                                        onClick={() => {
                                            setIsEditJobSeeking(true);
                                        }}
                                >
                                    Edit
                                </button>
                            </>
                        }
                    </div>
                    )}
                </div>
                <div className='card-body'>
                    <div className={'row'}>
                        <div className='input-group col-sm-12'>
                            <label className={'w-100'}>Chế độ tìm job hiện tại</label>
                            <select className='form-control'
                                    name={'current_find_job_mode'}
                                    disabled={!isEditJobSeeking}
                                    value={jobSeeking.current_find_job_mode ? jobSeeking.current_find_job_mode : ''}
                                    onChange={event => onChangeJobSeeking(event)}>
                                <option value=''>&nbsp;</option>
                                <option value='1'>On</option>
                                <option value='2'>Off</option>
                            </select>
                            <AllUserInputField arrInfo={allJobSeekingInfo}
                                               field='current_find_job_mode'/>
                        </div>
                    </div>
                    {mode !=='Search' && 
                    <div className={'input-group mt-1'}>
                        <button type='button' className='btn btn-warning btn-flat btn-sm'
                                onClick={() => {
                                    setShowJobFindModeHistoryModal(true)
                                }}>
                            View History
                        </button>
                    </div>
                    }

                    <div className={'row mt-3'}>
                        <div className='input-group col-sm-12'>
                            <label className={'w-100'}>Chế độ tìm job (DVTJCUV)</label>
                            <select className='form-control'
                                    name={'dvtjcuv_find_job_mode'}
                                    disabled={!isEditJobSeeking}
                                    value={jobSeeking.dvtjcuv_find_job_mode || ''}
                                    onChange={event => onChangeJobSeeking(event)}>
                                <option value=''>&nbsp;</option>
                                <option value='1'>On</option>
                                <option value='2'>Off</option>
                            </select>
                            <AllUserInputField arrInfo={allJobSeekingInfo}
                                               field='dvtjcuv_find_job_mode'/>
                        </div>
                        {mode !=='Search' && (
                        <div className='input-group col-sm-12 mt-3'>
                            <label className={'w-100'}>Note time ON gần nhất(DVTJCUV) </label>
                            {jobSeeking.last_on_dvtjcuv_find_job_mode_date_time}
                        </div>
                        )}

                        {mode === 'Search' && (
                            <div className='input-group col-sm-12 mt-3'>
                            <DateRange
                            containerClassName = 'card card-default w-100'
                            title={'Note time ON gần nhất(DVTJCUV)'}
                            startDate={jobSeeking?.last_on_dvtjcuv_find_job_mode_date_time?.start_date || ''}
                            endDate={jobSeeking?.last_on_dvtjcuv_find_job_mode_date_time?.end_date || ''}
                            onChangeStart={event => onChangeLastDate(event)}
                            onChangeEnd={event => onChangeLastDate(event)}
                            />
                            </div>
                        )}
                    </div>

                </div>
            </div>
            {isShowSearchCddJobModal &&
                <DVTJCUVSearchCddJobModal
                    cddId={candidateId}
                    isShow={isShowSearchCddJobModal}
                    onClose={() => setIsShowSearchCddJobModal(false)}
                />
            }
            {showJobFindModeHistoryModal &&
                <JobFindModeHistoryModal
                    candidateId={candidateId}
                    isShow={showJobFindModeHistoryModal}
                    onClose={() => setShowJobFindModeHistoryModal(false)}/>
            }
        </>
    );
};

export default CandidateJobSeeking;
